import { render, staticRenderFns } from "./SummaryBlock.vue?vue&type=template&id=7362de58&"
import script from "./SummaryBlock.vue?vue&type=script&lang=js&"
export * from "./SummaryBlock.vue?vue&type=script&lang=js&"
import style0 from "./SummaryBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports